import { Routes } from '@angular/router';
import { InitComponent } from './pages/init/init.component';

export const routes: Routes = [
  { path: '', redirectTo: '', pathMatch: 'full' },
  { path: '', component: InitComponent}
];
